import { Project } from "../types/projects"

export const PROJECTS: Project[] = [
  {
    id: 1,
    title: "Weather API App",
    description:
      "Weather API app, providing users with instant access to current weather conditions for any city, fetching real-time data from OpenWeatherMap. UI/UX design, and integration with external APIs.",
    madeWith: "React.js",
    link: "https://weatherappbyluka.netlify.app",
    imageUrl:
      "https://t4.ftcdn.net/jpg/04/85/17/33/360_F_485173339_rHVWOWEwZneJpHqgFNiYJLSPQg7hNoAA.jpg",
    alt: "Weather API App",
  },

  {
    id: 2,
    title: "To Do List Web App",
    description: "Responsive TO-DO list web app.",
    madeWith: "Vanilla JavaScript",
    link: "https://musing-euler-1dc837.netlify.app",
    imageUrl:
      "https://www.designeatrepeat.com/wp-content/uploads/printable-to-do-list-sq.png",
    alt: "To Do List Web App",
  },

  {
    id: 3,
    title: "Travel Blog",
    description:
      "Traveling Blog Template website. My first project where I implemented React.js",
    madeWith: "JavaScript & React.js",
    link: "https://goofy-hugle-0e111e.netlify.app",
    imageUrl:
      "https://st.depositphotos.com/1002489/1254/i/600/depositphotos_12544471-stock-photo-airplane-in-the-sky-at.jpg",
    alt: "Travel Blog",
  },

  {
    id: 4,
    title: "Basics Of Bodybuilding",
    description:
      "One of my first projects, a simple educational bodybuilding website. Contains a JavaScript calorie calculator. Serving as a guide to all the people interested in fitness and bodybuilding.",
    madeWith: "Vanilla JavaScript & Bootstrap.",
    link: "https://stupefied-jennings-a1c4e2.netlify.app",
    imageUrl:
      "https://thumbs.dreamstime.com/b/muscular-strong-bodybuilder-hands-power-up-vector-logo-mascot-sport-character-design-muscular-bodybuilder-hands-power-up-171525057.jpg",
    alt: "Basics Of Bodybuilding",
  },
]
